import i18n from 'i18next';

export enum FormResponseErrorType {
  INVITED_USER_ALREADY_REGISTERED = 'invitedUserAlreadyRegistered',
  EMAIL_DOMAIN_NOT_ALLOWED = 'emailDomainNotAllowed',
  PAGE_NOT_EXISTS = 'pageDoestNotExistYet',
  PAYLOAD_ERROR = 'payloadError',
  SUBPAGES_FAILED_TO_PUBLISH = 'subPagesFailedToPublish',
  INVALID_PARENTPAGES_FAILED_TO_PUBLISH = 'invalidParentPagesFailedToPublish',
  SUBPAGES_FAILED_TO_DEPUBLISH = 'subPagesFailedToDepublish',
  PAGE_CREATE_DUPLICATE_AREA_HOME_PAGE = 'pageCreateDuplicateAreaHomePage',
  NO_TEAMROOM_APPROVER_FOUND = 'noTeamroomApproverFound',
  PAGE_LOCKED = 'pageLocked',
  DUPLICATED_ID = 'duplicateId',
  INVALID_SELF_ASSIGNMENT = 'invalidSelfAssignment',
  INVALID_FILES = 'invalidFiles',
  INVALID_FILE = 'invalidFile',
  INVALID_VERSION_STATE = 'invalidVersionState',
  EXPIRED_SESSION_OR_CSRF = 'expiredSessionOrCsrf',
  INVALID_CSV_FILE = 'invalidCsvFile',
  MISSING_BUT_REQUIRED = 'missingButRequired',
  INVALID_HTML = 'invalidHtml',
  MISSING_POST = 'missingPost',
  PAGE_TYPE_IS_NOT_COPYABLE = 'pageTypeIsNotCopyable',
  INVALID_VALUE = 'invalidValue',
  GENERIC_ERROR = 'genericError',
}

export const getErrorMessagesForFormResponseErrors = () => {
  return Object.values(FormResponseErrorType).reduce(
    (acc, value) => {
      acc[value] = i18n.exists(`Form:errorType.${value}`)
        ? i18n.t(`Form:errorType.${value}`)
        : `Form:errorType.${value}`;
      return acc;
    },
    {} as any);
};
